import { useForm } from "react-hook-form";
import { CmpCarInfoContent } from "../../../components/organisms/CmpPageContent/CmpCarInfoContent";
import { CmpTemplates } from "../../../components/template/CmpTemplates";
import { VehicleInfoRegistrationType } from "../../../interface/transportation";
import { useRecoilState } from "recoil";
import { userSignState } from "../../../states/user-sign-up";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const CmpCarInfoPage = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, watch, reset } = useForm<any>({
    defaultValues: {
      vehicleNumber: "",
      vehicleType: "차종",
      standard: "규격",
      chassis: "샤시",
      vehicleFeatures: [],
    },
  });
  const [isButtonTrue, setIsButtonTrue] = useState<boolean>(false);

  const [userSignUpData, setUserSignUp] = useRecoilState(userSignState);

  useEffect(() => {
    reset(userSignUpData.userDriverInfo);
  }, [userSignUpData.userDriverInfo]);

  useEffect(() => {
    const isTrue = Object.values(watch()).some(
      (value: any) =>
        typeof value === "string" &&
        value !== "차종" &&
        value !== "규격" &&
        value !== "샤시"
    );

    setIsButtonTrue(isTrue);
  }, [watch()]);

  /** 데이터 전송 */
  const onSubmit = (data: VehicleInfoRegistrationType) => {
    if (data.vehicleType === "차종") {
      alert("차종을 입력하세요.");
      return;
    }
    if (data.standard === "규격") {
      alert("규격을 입력하세요.");
      return;
    }

    if (data.chassis === "샤시") {
      alert("샤시를 입력하세요.");
      return;
    }

    setUserSignUp((prev: any) => ({
      ...prev,
      userDriverInfo: {
        vehicleNumber: data.vehicleNumber,
        vehicleType: data.vehicleType,
        standard: data.standard,
        chassis: data.chassis,
        vehicleFeatures: data.vehicleFeatures,
      },
    }));

    navigate("/cmp-cargo-page");
  };

  const onBackHandler = () => {
    navigate(-1);
  };

  return (
    <CmpTemplates pageTitle="회원가입">
      <CmpCarInfoContent
        register={register}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        setValue={setValue}
        watch={watch}
        onBackHandler={onBackHandler}
        isButtonTrue={isButtonTrue}
      />
    </CmpTemplates>
  );
};

export default CmpCarInfoPage;
